import React, { useState } from "react"
import ImageWithFallback from "../../../ui/components/ImageWithFallback"

const ReleaseCoverEditRequestBadge = ({
  coverFileUrl,
  hasEditRequest,
  onApprove
}: {
  coverFileUrl: string
  hasEditRequest: boolean
  onApprove: () => void
}) => {
  const [hovered, setHovered] = useState(false)

  return (
    <div className="relative no-parent-trigger" style={{ width: 40, height: 40 }}>
      <ImageWithFallback coverFileUrl={coverFileUrl} />
      {hasEditRequest && (
        <div
          data-testid="release-edit-request-badge"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={(e) => {
            e.stopPropagation()
            onApprove()
          }}
          className="absolute flex items-center justify-center cursor-pointer"
          style={{
            top: -6,
            left: 26,
            height: 20,
            width: hovered ? 140 : 20,
            borderRadius: 10,
            backgroundColor: hovered ? "#E65100" : "#FF8A00",
            border: "2px solid #FFF",
            boxSizing: "content-box",
            overflow: "hidden",
            transition: "width 0.25s ease, background-color 0.25s ease"
          }}
        >
          <span
            style={{
              color: "#FFF",
              fontSize: 11,
              fontWeight: 600,
              whiteSpace: "nowrap",
              opacity: hovered ? 1 : 0,
              transition: hovered ? "opacity 0.15s ease 0.1s" : "opacity 0.1s ease"
            }}
          >
            Approve Edit Request
          </span>
        </div>
      )}
    </div>
  )
}

export default React.memo(ReleaseCoverEditRequestBadge)